(function () {
  'use strict';

  if (window.svipDealProductCardsReady) return;
  window.svipDealProductCardsReady = true;

  document.addEventListener('click', async function (event) {
    var copyButton = event.target.closest('[data-deal-copy]');
    if (copyButton) {
      var code = copyButton.getAttribute('data-deal-copy');
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        var label = copyButton.querySelector('span');
        if (label) {
          var original = label.textContent;
          label.textContent = 'Copied';
          window.setTimeout(function () { label.textContent = original; }, 1600);
        }
      } catch (_error) {
        window.prompt('Copy coupon code:', code);
      }
      return;
    }

    var shareButton = event.target.closest('[data-deal-share]');
    if (!shareButton) return;
    var url = shareButton.getAttribute('data-share-url') || window.location.href;
    var title = shareButton.getAttribute('data-share-title') || document.title;
    try {
      if (navigator.share) await navigator.share({ title: title, url: url });
      else await navigator.clipboard.writeText(url);
    } catch (error) {
      if (error && error.name !== 'AbortError') window.prompt('Copy deal link:', url);
    }
  });
})();
